import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\GetThreadByGroupIdController::__invoke
* @see app/Http/Controllers/ModelNotification/GetThreadByGroupIdController.php
* @route '/api/model-notification/thread/{group_id}'
*/
const GetThreadByGroupIdController = (args: { group_id: string | number } | [group_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetThreadByGroupIdController.url(args, options),
    method: 'get',
})

GetThreadByGroupIdController.definition = {
    methods: ["get","head"],
    url: '/api/model-notification/thread/{group_id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ModelNotification\GetThreadByGroupIdController::__invoke
* @see app/Http/Controllers/ModelNotification/GetThreadByGroupIdController.php
* @route '/api/model-notification/thread/{group_id}'
*/
GetThreadByGroupIdController.url = (args: { group_id: string | number } | [group_id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { group_id: args }
    }

    if (Array.isArray(args)) {
        args = {
            group_id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        group_id: args.group_id,
    }

    return GetThreadByGroupIdController.definition.url
            .replace('{group_id}', parsedArgs.group_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\GetThreadByGroupIdController::__invoke
* @see app/Http/Controllers/ModelNotification/GetThreadByGroupIdController.php
* @route '/api/model-notification/thread/{group_id}'
*/
GetThreadByGroupIdController.get = (args: { group_id: string | number } | [group_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetThreadByGroupIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ModelNotification\GetThreadByGroupIdController::__invoke
* @see app/Http/Controllers/ModelNotification/GetThreadByGroupIdController.php
* @route '/api/model-notification/thread/{group_id}'
*/
GetThreadByGroupIdController.head = (args: { group_id: string | number } | [group_id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetThreadByGroupIdController.url(args, options),
    method: 'head',
})

export default GetThreadByGroupIdController